enum ApiCallServiceType {
	Alert,
	KioskSession,
	LegacyKioskSession,
	NavSession,
	DigitalReceipt,
	LegacyPostAcceptedPayment,
	LegacyPostRejectedPayment,
	PostCashPayment,
}

interface ApiCall {
	id: string;
	timestamp: Date;
	type: ApiCallServiceType;
	requestData: string;
}

export default ApiCall;
export { ApiCallServiceType };
